var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "re-import",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.38443497,6.25158691 L5.62925954,4.49641148 L6.68991971,3.43575131 L10.2254536,6.97128522 L10.2238136,6.97292524 L10.2423717,6.99148334 L6.70683779,10.5270172 L5.64617762,9.46635707 L7.36094778,7.75158691 L-1.56319402e-13,7.75158691 L-1.56319402e-13,6.25158691 L7.38443497,6.25158691 Z M1.9901123,9.99108887 L3.4901123,9.99108887 L3.4901123,12.5 L11.4901123,12.5 L11.4901123,4.27603426 L8.95879242,1.5 L3.4901123,1.5 L3.4901123,3.99108887 L1.9901123,3.99108887 L1.9901123,0 L9.62099609,0 L12.9901123,3.69482422 L12.9901123,14 L1.9901123,14 L1.9901123,9.99108887 Z",
    id: "icon-re-import",
    fill: "#6D7A90"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReImport);
export default __webpack_public_path__ + "static/media/re-import.10312005c2a64e0c43cb13acbd754ea7.svg";
export { ForwardRef as ReactComponent };